import { render, staticRenderFns } from "./college_list.vue?vue&type=template&id=748af0bb&scoped=true"
import script from "./college_list.vue?vue&type=script&lang=js"
export * from "./college_list.vue?vue&type=script&lang=js"
import style0 from "./college_list.vue?vue&type=style&index=0&id=748af0bb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748af0bb",
  null
  
)

export default component.exports